import React, { Component } from "react";
import { Card, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import AppConfig from "../../../../config/AppConfig";
import swal from "sweetalert";
import Moment from "react-moment";
import { NoticeVerificator } from "../../../../../_metronic/_partials/controls";
import { Badge, Button, Table, Form } from "react-bootstrap";
import { Router } from "react-router";

class Verifikator extends Component {
  state = {
    data: [],
    comment: [],
    display: false,
    statusajuan: "",
    dokumen_valid: "",
    catatan: "",
    counter: 0,
    comment_status: false,
    id_reply: "",
    description: "",
    level: "",
    komentar: "",
    counter_komentar: 0,
    balas_komentar: "",
    counter_balas_komentar: 0,
    loading_comment: false,
    loading_reply_comment: false,
  };

  componentDidMount() {
    const url = window.location.pathname;
    var id = url.substring(url.lastIndexOf("/") + 1);
    // let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session =
      // "?token="+userdata.token+
      "?id_pengguna=" +
      userdata.id_pengguna +
      "&id_unit=" +
      sessiondata.i_idunit +
      "&id_role=" +
      sessiondata.i_idrole;
    Axios.get(
      AppConfig.urlDetailAjuan + "/" + id + sessiondata.i_idunit + session
    )
      .then((res) => {
        this.setState(
          {
            data: res.data.result.data,
            comment: res.data.result.comment,
            statusajuan: res.data.result.data.statusajuan,
            dokumen_valid: res.data.result.data.dokumen_valid,
            catatan: res.data.result.data.catatan,
            display: true,
          },
          () => {
            console.log(this.state.data);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onChangeVal = (e, type) => {
    this.setState({
      [type]: e.target.value,
      counter: e.target.value.length,
    });
  };

  saveKesimpulan = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    console.log(this.state);
    var id = this.state.data.id_ajuan_pengaturan;
    // console.log("ID++++ : ", id);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    e.preventDefault();
    var formData = new FormData();
    formData.append("data[id_ajuan_pengaturan]", id);
    formData.append("data[catatan]", this.state.catatan);
    formData.append("data[statusajuan]", this.state.statusajuan);
    formData.append("data[dokumen_valid]", this.state.dokumen_valid);

    Axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    Axios.post(AppConfig.urlAPiPostDataPT + session, formData)
      .then((res) => {
        swal({
          title: "Berhasil!",
          text: "Proses perubahan ajuan selesai!",
          icon: "success",
          button: "OK!",
        });
        this.goBack();
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        // console.log(err)
        swal({
          title: "Gagal!",
          text: "perubahan yang dilakukan gagal!",
          icon: "error",
          button: "OK!",
        });
        this.setState({
          loading: false,
        });
      });
  };

  onChangeValKomentar = (e) => {
    this.setState({
      komentar: e.target.value,
      counter_komentar: e.target.value.length,
    });
  };
  onChangeValBalasKomentar = (e) => {
    this.setState({
      balas_komentar: e.target.value,
      counter_balas_komentar: e.target.value.length,
    });
  };

  replyComment = (id_comment, description, level) => {
    this.setState({
      comment_status: true,
      id_reply: id_comment,
      description: description,
      level: level,
    });
    this.scrollToBottom(2);
  };

  deleteComment = (id_comment) => {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Komentar akan dihapus dari list",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        Axios.put(AppConfig.CommentDelete + id_comment + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Komentar berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });

            if (res.data.status === "sukses") {
              swal({
                title: "Sukses!",
                text: "Komentar berhasil dihapus!",
                icon: "success",
                button: "OK!",
              });
              this.componentDidMount();
            } else {
              swal({
                title: "Gagal!",
                text: "Gagal menghapus Komentar!",
                icon: "error",
                button: "OK!",
              });
            }
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus Komentar!",
              icon: "error",
              button: "OK!",
            });
          });
      }
    });
  };

  cancelReplyComment = (e) => {
    this.setState({
      comment_status: false,
      id_reply: "",
      description: "",
      level: "",
      balas_komentar: "",
    });
  };

  scrollToBottom = (timedelay = 0) => {
    var scrollId;
    var height = 0;
    var minScrollHeight = 100;
    scrollId = setInterval(function() {
      if (height <= document.body.scrollHeight) {
        window.scrollBy(0, minScrollHeight);
      } else {
        clearInterval(scrollId);
      }
      height += minScrollHeight;
    }, timedelay);
  };

  submitComment = (e) => {
    e.preventDefault();
    if (this.state.id_reply === "") {
      this.setState({ loading_comment: true });
    } else {
      this.setState({ loading_reply_comment: true });
    }

    var id = this.state.data.id_ajuan_pengaturan;

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    var formData = new FormData();
    if (this.state.id_reply === "") {
      formData.append("data[id_reply]", "");
      formData.append("data[description]", this.state.komentar);
      formData.append("data[id_ref]", id);
      formData.append("data[level]", "0");
      formData.append("data[tipe]", "1");
    } else {
      formData.append("data[id_reply]", this.state.id_reply);
      formData.append("data[description]", this.state.balas_komentar);
      formData.append("data[id_ref]", id);
      formData.append("data[level]", this.state.level);
      formData.append("data[tipe]", "1");
    }

    Axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    Axios.post(AppConfig.CommentSave + session, formData)
      .then((res) => {
        if (this.state.id_reply === "") {
          this.setState({ loading_comment: false });
        } else {
          this.setState({ loading_reply_comment: false });
        }
        if (res.data.status === "sukses") {
          this.setState({
            comment_status: false,
            id_reply: "",
            description: "",
            level: "",
            balas_komentar: "",
            komentar: "",
          });
          swal({
            title: "Berhasil!",
            text: "Menambah komentar berhasil!",
            icon: "success",
            button: "OK!",
          });
          this.componentDidMount();
        } else {
          swal({
            title: "Gagal!",
            text: "Menambah komentar gagal!",
            icon: "error",
            button: "OK!",
          });
        }
      })
      .catch((err) => {
        if (this.state.id_reply === "") {
          this.setState({ loading_comment: false });
        } else {
          this.setState({ loading_reply_comment: false });
        }
        swal({
          title: "Gagal!",
          text: "Menambah komentar gagal!",
          icon: "error",
          button: "OK!",
        });
      });
  };

  goBack() {
    window.history.back();
  }
  render() {
    let {
      data,
      comment,
      display,
      statusajuan,
      dokumen_valid,
      catatan,
    } = this.state;
    console.log("statusajuan =", statusajuan);
    console.log("catatan =", catatan);
    let views = [];
    let edit = [];
    let nama_jenis = [];

    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log("data =", data);
    if (data !== undefined) {
      if (data.id_jenis_aturan === 1) {
        nama_jenis = "Pengaturan pengelolaan SPMI Institusi";
      } else if (data.id_jenis_aturan === 2) {
        nama_jenis = "Pengaturan organisasi pengelola SPMI Institusi";
      } else if (data.id_jenis_aturan === 3) {
        nama_jenis =
          "Pengaturan terkait pelaksanaan standar dalam SPMI Institusi";
      } else if (data.id_jenis_aturan === 4) {
        nama_jenis = "Pengaturan terkait evaluasi pelaksanaan standar";
      } else if (data.id_jenis_aturan === 5) {
        nama_jenis = "Pengaturan terkait pengendalian pelaksanaan standar";
      } else if (data.id_jenis_aturan === 6) {
        nama_jenis =
          "Pengaturan terkait peningkatan standar dalam SPMI Institusi";
      }
      if (display === true) {
        let list_comment = [];
        (comment || []).map((list, i) => {
          let dc = "";
          if (list.id_parent_comment === "null") {
            dc = (
              <>
                <div className="bg-gray-100 p-5 mt-2 mb-2 rounded">
                  <div className="font-weight-bold mb-2">{list.nama_user}</div>
                  <p>{list.description}</p>
                  <div className="text-right font-size-sm font-italic">
                    <Moment date={list.created_at} format="DD/MM/YYYY HH:ss" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-10"></div>
                  <div className="col-2">
                    <div className="row">
                      {list.id_updater !=
                      JSON.parse(localStorage.getItem("userdata"))
                        .id_pengguna ? (
                        <div className="col-6 text-center"></div>
                      ) : (
                        ""
                      )}
                      {list.balas_disable === 0 ? (
                        <div className="col-6 text-right">
                          <a
                            href="#"
                            onClick={() =>
                              this.replyComment(
                                list.id_comment,
                                list.description,
                                "0"
                              )
                            }
                            className="text-underline color-primary"
                          >
                            Balas{" "}
                          </a>
                        </div>
                      ) : (
                        <div className="col-6 text-center"></div>
                      )}

                      {list.id_updater ==
                      JSON.parse(localStorage.getItem("userdata"))
                        .id_pengguna ? (
                        <div className="col-6 text-center">
                          <a
                            href="#"
                            onClick={() => this.deleteComment(list.id_comment)}
                            className="text-danger"
                          >
                            Hapus
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </>
            );
          } else {
            dc = (
              <div className="row mb-2">
                <div className="col-2"></div>
                <div className="col-10">
                  <div className="bg-gray-100 p-5 mt-4 mb-2 rounded">
                    <div className="bg-gray-200 font-italic p-5 mb-4 rounded">
                      <q>
                        <b>{list.description2}</b>
                      </q>
                    </div>
                    <div className="font-weight-bold mb-2">
                      {list.nama_user}
                    </div>
                    <p>{list.description}</p>
                    <div className="text-right font-size-sm font-italic">
                      <Moment
                        date={list.created_at}
                        format="DD/MM/YYYY HH:ss"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-10"></div>
                    <div className="col-2">
                      <div className="row">
                        {list.id_updater !=
                        JSON.parse(localStorage.getItem("userdata"))
                          .id_pengguna ? (
                          <div className="col-6 text-center"></div>
                        ) : (
                          ""
                        )}
                        {list.balas_disable === 0 ? (
                          <div className="col-6 text-right">
                            <a
                              href="#"
                              onClick={() =>
                                this.replyComment(
                                  list.id_comment,
                                  list.description,
                                  "1"
                                )
                              }
                              className="text-underline color-primary"
                            >
                              Balas{" "}
                            </a>
                          </div>
                        ) : (
                          <div className="col-6 text-center"></div>
                        )}

                        {list.id_updater ==
                        JSON.parse(localStorage.getItem("userdata"))
                          .id_pengguna ? (
                          <div className="col-6 text-center">
                            <a
                              href="#"
                              onClick={() =>
                                this.deleteComment(list.id_comment)
                              }
                              className="text-danger"
                            >
                              Hapus
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          list_comment.push(dc);
        });
        let reply_comment = "";
        if (this.state.comment_status === true) {
          reply_comment = (
            <>
              <hr></hr>
              <h3>Balas Komentar :</h3>
              <div
                className="bg-gray-100 p-5 mt-4 mb-2 rounded"
                id="reply_comment"
              >
                <div className="bg-gray-200 font-italic p-5 mb-4 rounded">
                  <q>
                    <b>{this.state.description}</b>
                  </q>
                </div>
                <div className="row">
                  <div className="col-10">
                    <Form.Control
                      as="textarea"
                      size="lg"
                      rows="2"
                      maxlength="500"
                      className="resize-none"
                      autoFocus="true"
                      value={this.state.balas_komentar}
                      onChange={(e) => this.onChangeValBalasKomentar(e)}
                    />
                    <small>{this.state.counter_balas_komentar} / 500</small>
                  </div>
                  <div className="col-2 p-0">
                    <div className="row">
                      <div className="col-12">
                        <button
                          type="button"
                          onClick={this.submitComment}
                          className={`btn btn-primary font-weight-bold p-3`}
                        >
                          {this.state.loading_reply_comment ? (
                            <i className="mr-4 spinner spinner-white"></i>
                          ) : (
                            "Kirim"
                          )}
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary ml-3"
                          onClick={this.cancelReplyComment}
                        >
                          Batalkan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }
        edit = (
          <>
            <div className="row row-paddingless">
              <div className="col-md-12" style={{ padding: "1%" }}>
                <Form.Group
                  controlId="formGridState"
                  style={{ minWidth: "300px" }}
                >
                  <Form.Label>Verikasi Pengaturan :</Form.Label>
                  <Form.Control
                    value={statusajuan}
                    as="select"
                    name="kesimpulan"
                    onChange={(e) => this.onChangeVal(e, "statusajuan")}
                  >
                    <option>Pilih...</option>
                    <option
                      value="1"
                      selected={statusajuan === 1 ? true : false}
                    >
                      Belum Terverifikasi
                    </option>
                    <option
                      value="3"
                      selected={statusajuan === 3 ? true : false}
                    >
                      Verifikasi
                    </option>
                  </Form.Control>
                </Form.Group>
                <Form.Group
                  controlId="formGridState"
                  style={{ minWidth: "300px" }}
                >
                  <Form.Label>Status Dokumen :</Form.Label>
                  <Form.Control
                    value={dokumen_valid}
                    as="select"
                    name="kesimpulan"
                    onChange={(e) => this.onChangeVal(e, "dokumen_valid")}
                  >
                    <option>Pilih...</option>
                    <option
                      value="1"
                      selected={dokumen_valid === "1" ? true : false}
                    >
                      Valid
                    </option>
                    <option
                      value="0"
                      selected={dokumen_valid === "0" ? true : false}
                    >
                      Tidak Valid
                    </option>
                  </Form.Control>
                </Form.Group>
                {/* <Form.Group controlId="exampleForm.ControlTextarea1">
                  <Form.Label>
                    Pesan / Catatan <small>*maks 500 karakter</small>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    size="lg"
                    rows="4"
                    maxlength="500"
                    className="resize-none"
                    value={catatan !== "null" ? catatan : ""}
                    onChange={(e) => this.onChangeVal(e, "catatan")}
                  />{" "}
                  <small>{this.state.counter} / 500</small>
                </Form.Group> */}
                <p>
                  <button
                    type="submit"
                    onClick={this.saveKesimpulan}
                    disabled={this.state.loading}
                    className="btn btn-primary"
                  >
                    SIMPAN{" "}
                    {this.state.loading && (
                      <i className="mx-4 spinner spinner-white"></i>
                    )}
                  </button>
                  &nbsp;&nbsp;
                  <Button
                    className="btn btn-secondary"
                    onClick={this.goBack}
                    disabled={this.state.loading}
                  >
                    Batalkan
                  </Button>
                </p>
                {/* <label  className="labelstyle">Verikasi Pengaturan :</label>
                    <select className="selectstyle" >
                        <option readonly value="">--Pilih--</option>
                        <option value="3" selected={ statusajuan === "3" ? true : false }>Verifikasi</option>
                    </select> */}
                {/* <label className="labelstyle">Pesan / Catatan :</label>
                    <textarea
                        className="inputstyle"
                        name="catatan"
                        value={catatan}
                        onChange={(e) => this.onChangeVal(e, 'catatan')}
                    ></textarea>
                    <input type="submit" onClick={this.saveKesimpulan} disabled={this.state.loading} className="btn btn-primary" value='SIMPAN' /> */}
              </div>
            </div>
          </>
        );
        views = (
          <>
            <strong style={{ fontSize: "18px" }}>{nama_jenis}</strong>
            <br />
            <Table borderless responsive style={{ overflow: "auto" }}>
              <tr>
                <th>Nama Lembaga</th>
                <th>:</th>
                <td>{data.nm_lemb}</td>
              </tr>
              {data.id_jenis_aturan === 17 || data.id_jenis_aturan === 19 || data.id_jenis_aturan === 24 || data.id_jenis_aturan === 23 || data.id_jenis_aturan === 22 ? (
                ""
              ) : (
              <tr>
                <th>Status Pengaturan</th>
                <th>:</th>
                <td>
                  {data.status === 1 ? (
                    <>
                      Ada <i className="text-success flaticon2-check-mark" />
                    </>
                  ) : data.status === 0 ? (
                    "Tidak Ada"
                  ) : data.status === 2 ? (
                    "Dalam unit tersendiri"
                  ) : data.status === 3 ? (
                    <>
                      <i>Embedded</i>dalam organisasi institusi
                    </>
                  ) : data.status === 4 ? (
                    <>
                      <i>embedded</i>Kombinasi unit pengelola dan{" "}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
              )}
              {data.keterangan === "null" ? (
                ""
              ) : (
                <tr>
                  <th>Keterangan</th>
                  <th>:</th>
                  <td>{data.keterangan}</td>
                </tr>
              )}
                <tr>
                  <th>Catatan PT</th>
                  <th>:</th>
                  <td>{data.deskripsi !== "null" ? data.deskripsi : "-"}</td>
                </tr>
              {data.tautan === "null" ? (
                ""
              ) : (
                <tr>
                  <th>Tautan</th>
                  <th>:</th>
                  <td>
                    {data.tautan}&nbsp;&nbsp;
                    <Button
                      href={data.tautan}
                      target="_blank"
                      className="btn btn-icon btn-light btn-sm"
                      style={{
                        minWidth: "50px",
                        borderRadius: "12px",
                        background: "#A9C6DE",
                      }}
                    >
                      <i
                        class="flaticon-attachment"
                        style={{ color: "#3F4254", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </td>
                </tr>
              )}
              <tr>
                <th>Status Ajuan</th>
                <th>:</th>
                <td>
                  {data.statusajuan === 1 ? (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Belum Terverifikasi
                    </Badge>
                  ) : (
                    <Badge
                      pill
                      variant="success"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Terverifikasi
                    </Badge>
                  )}
                </td>
              </tr>
              <tr>
                <th>Status Dokumen</th>
                <th>:</th>
                <td>
                  {data.dokumen_valid === "1" ? (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Valid
                    </Badge>
                  ) : data.dokumen_valid === "0" ? (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Tidak Valid
                    </Badge>
                  ) : data.dokumen_valid === "null" ? (
                    <Badge
                      pill
                      variant="secondary"
                      style={{
                        backgroundColor: "#BEF2FF",
                        color: "#334443",
                        fontSize: "12px",
                      }}
                    >
                      Belum Terverifikasi
                    </Badge>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
              {/* <tr>
                <th>Catatan Verifikator</th>
                <th>:</th>
                <td>{data.catatan !== "null" ? data.catatan : "-"}</td>
              </tr> */}
              {sessiondata.i_idrole !== 3 ? (
                <tr>
                  <th>Updater</th>
                  <th>:</th>
                  <td>{data.updater}</td>
                </tr>
              ) : (
                ""
              )}
              <tr>
                <th>Tanggal Dibuat</th>
                <th>:</th>
                <td>
                  <Moment
                    date={data.created_at ? data.created_at : "loading .."}
                    format="DD/MM/YYYY"
                  />
                </td>
              </tr>
              {data.tanggal_penetapan !== "null" ? (
              <tr>
                <th>Tanggal Penetapan</th>
                <th>:</th>
                <td>
                    <Moment
                      date={
                        data.tanggal_penetapan
                          ? data.tanggal_penetapan
                          : "loading .."
                      }
                      format="DD/MM/YYYY"
                    />
                </td>
              </tr>
              ) : ""}
              <tr>
                <th>Tanggal Verifikasi</th>
                <th>:</th>
                <td>
                  {data.updated_at !== "null" ? (
                    <Moment
                      date={data.updated_at ? data.updated_at : "loading .."}
                      format="DD/MM/YYYY"
                    />
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            </Table>
            <h3>Komentar</h3>
            {sessiondata.i_idrole !== "3" || sessiondata.i_idrole !== 3 ? (
              <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>
                  <small>*maks 500 karakter</small>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  size="lg"
                  rows="4"
                  maxlength="500"
                  className="resize-none"
                  value={this.state.komentar}
                  onChange={(e) => this.onChangeValKomentar(e)}
                />{" "}
                <small>{this.state.counter_komentar} / 500</small>
                <div className="my-3 align-right">
                  <button
                    onClick={this.submitComment}
                    className="btn btn-primary mr-2"
                  >
                    KIRIM
                    {this.state.loading_comment && (
                      <i className="mx-4 spinner spinner-white"></i>
                    )}
                  </button>
                </div>
              </Form.Group>
            ) : (
              ""
            )}
            {data.catatan !== "null" ? (
              <div className="bg-gray-100 p-5 mt-2 mb-2 rounded">
                <div className="font-weight-bold mb-2">Catatan Verifikator</div>
                <p>{data.catatan}</p>
              </div>
            ) : (
              ""
            )}

            {list_comment}
            {reply_comment}
          </>
        );
      } else {
        views = (
          <>
            <LinearProgress color="secondary" variant="query" />
          </>
        );
        edit = (
          <>
            <LinearProgress color="secondary" variant="query" />
          </>
        );
      }
    }

    return (
      <>
        <div className="row row-paddingless">
          <div
            className="col-md-12 text-right"
            style={{ marginBottom: "20px" }}
          >
            <Button className="btn btn-primary" onClick={this.goBack}>
              <i className="flaticon2-back"></i>
              Kembali
            </Button>
          </div>
        </div>
        <NoticeVerificator style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Detail Pengaturan</strong>
          <p>Pengaturan Tentang Kebijakan SPMI (PPEPP)</p>
        </NoticeVerificator>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row row-paddingless">
            <div className="col-md-8" style={{ padding: "1%" }}>
              {views}
            </div>
            <div className="col-md-4" style={{ padding: "1%" }}>
              {// SUPER ADMIN
              sessiondata.i_idrole === 1 ||
              sessiondata.i_idrole === "1" ||
              // BELMAWA
              sessiondata.i_idrole === 10 ||
              sessiondata.i_idrole === "10" ||
              // REVIEWER
              sessiondata.i_idrole === 2013 ||
              sessiondata.i_idrole === "2013"
                ? edit
                : ""}
              {/* {edit} */}
            </div>
          </div>
        </Card>
        <br />
      </>
    );
  }
}
export default Verifikator;
